import { RiBookOpenLine } from '@remixicon/react';

import {
  ToolLabel,
  createToolExtension,
  mcpTool,
} from '@spotify/plugin-confidence-chat-react';

import { confidenceChatPlugin } from '../plugin';
import { getInputString, getToolInput } from './parseToolResult';

const getSkillName = (input: unknown): string | undefined => {
  const values = getToolInput(input);
  return getInputString(values, 'name') ?? getInputString(values, 'skill');
};

export const SkillToolExtension = confidenceChatPlugin.provide(
  createToolExtension({
    id: 'skill',
    predicate: mcpTool('Skill'),
    icon: RiBookOpenLine,
    display: 'grouped',
    collapseConsecutiveCalls: false,
    render: () => null,
    renderLabel: (entry, { isStreaming }) => {
      const skillName = getSkillName(entry.input);
      let label = 'Loading skill';
      if (!isStreaming && entry.result) {
        label = entry.result.success ? 'Loaded skill' : 'Failed to load skill';
      }

      return (
        <ToolLabel.Root>
          <ToolLabel.Primary>
            {label}
            {skillName && (
              <>
                {' '}
                <span title={skillName}>{skillName}</span>
              </>
            )}
          </ToolLabel.Primary>
          <ToolLabel.Timer
            startedAt={entry.result ? undefined : entry.startedAt}
          />
        </ToolLabel.Root>
      );
    },
  }),
);
